export const CHAT_SELF_ID = 'chat-self';

export const CHAT_MODAL_WIDTH_CLASS = 'mx-4 w-full max-w-[552px]';

export const CHAT_GROUP_AVATAR_ACCEPT = 'image/png,image/jpeg,image/jpg';
export const CHAT_GROUP_MAX_PARTICIPANTS = 50;
export const CHAT_LIST_PAGE_SIZE = 20;
export const CHAT_LIST_SEARCH_DEBOUNCE_MS = 300;
export const CHAT_LIST_SCROLL_THRESHOLD_PX = 120;
export const CHAT_USERNAME_SEARCH_MAX = 255;
export const CHAT_MESSAGE_MAX_LENGTH = 5000;
export const CHAT_MESSAGE_TOO_LONG_ERROR = 'Text must be at most 5000 characters';
export const CHAT_MESSAGES_PAGE_SIZE = 30;
export const CHAT_MESSAGES_PAGE_MAX = 100;
export const CHAT_MESSAGES_SCROLL_TOP_THRESHOLD_PX = 120;

export const CHAT_UNREAD_TOTAL_STORAGE_KEY = 'ihcl-chat-unread-total';

export const CHAT_UNREAD_BADGE_CLASS =
  'flex h-5 min-w-5 shrink-0 items-center justify-center rounded-full bg-[#1B2A4A] px-1 text-[10px] font-semibold leading-none text-white tabular-nums';
